// @flow
import parseLatLng from 'mz-utils/parseLatLng'
import STEP_TYPE from '../../../constants/stepType'
import buildWalkStep from './walkSearchStep'

// Types
import type { Location } from '../../../models/location'
import type { Step } from '../../../models/step'

/**
 * Converts location back to API detailed locatino type, just to be
 * able to reuse existing walk step builder
 * @param  {Location} loc
 * @return {DetailedPlace}
 */
function buildRawDetailedLocation(loc: Location) {
  return {
    name: loc.name,
    custom_name: loc.customName,
    formatted_address: loc.address,
    full_address: loc.fullAddress,
    iata_code: !loc.isTrainStation ? loc.iataCode : '',
    rail_iata_code: loc.isTrainStation ? loc.iataCode : '',
    country: loc.country || '',
    not_specific: loc.notSpecific ? 1 : 0,
    timezone: loc.timezone,
    place_id: loc.placeId,
    is_cruise_port: loc.isCruisePort,
    is_train_station: loc.isTrainStation,
    zipcode: '',
    sublocality: '',
    state: '',
    city: '',
    google_hotel: false,
    google_establishment: false,
    icao_code: '',
    lang: '',
    neighborhood: '',
    route: '',
    source: 0,
    street_number: '',
    ...parseLatLng(loc.lat, loc.lng),
  }
}

/**
 * Actually build a walking step for given step with non-zero
 * distance and particular location
 * @param  {[type]} step: Step
 * @param  {[type]} loc:  StepLocation
 * @return {[type]}
 */
function buildWalkStepForStep(step: Step, type: 'from' | 'to'): ?Step {
  const location = step[type]
  const startLocation = type === 'from' ? location.location : location.station
  const endLocation = type === 'from' ? location.station : location.location

  if (!startLocation || !endLocation) {
    return null
  }

  return buildWalkStep({
    main: false,
    step_type: STEP_TYPE.WALK,
    details: {
      start_location: buildRawDetailedLocation(startLocation),
      end_location: buildRawDetailedLocation(endLocation),
      distance_meters: location.distance * 1609.344,
      distance_miles: location.distance,
      time_seconds: 0,
      description: '',
    },
  })
}

/**
 * Right now our API do not return walk steps for all trips where it
 * have to be presented. This function analize provided array of steps
 * and return new array of steps with walk steps appended if necessary.
 * @param  {Step[]} steps
 * @param  {PartialResponse} response
 * @return {Step[]}
 */
function appendWalkSteps(steps: Step[]): Step[] {
  return steps.reduce((acc, step, i) => {
    if (
      step.from.distance > 0 &&
      step.type !== STEP_TYPE.WALK &&
      (!steps[i - 1] || steps[i - 1].type !== STEP_TYPE.WALK)
    ) {
      const walkStep = buildWalkStepForStep(step, 'from')
      walkStep && acc.push(walkStep)
    }

    acc.push(step)

    if (
      step.to.distance > 0 &&
      step.type !== STEP_TYPE.WALK &&
      (!steps[i + 1] || steps[i + 1].type !== STEP_TYPE.WALK)
    ) {
      const walkStep = buildWalkStepForStep(step, 'to')
      walkStep && acc.push(walkStep)
    }
    return acc
  }, [])
}

export default appendWalkSteps
